import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { TransitionConfig } from 'library/constants/styles-config';
import { IconBase } from '../../styles/icon';

export const Container = styled.nav`
  top: 71px;
  display: flex;
  justify-content: space-between;
  z-index: 19;
  padding: 5px 20px 5px 24px;
  font-size: 13px;
  font-weight: bold;
  color: ${Colors.shade02};
  background-color: ${Colors.shade07};
  box-shadow: 0 2px 36px rgb(45 49 50 / 10%);
  
  em {
    font-style: normal;
  }
  
  p {
    font-weight: normal;
    color: ${Colors.shade03};
  }
`;

const FilterBase = styled.span`
  display: inline-block;
  padding: 7px 8px 7px 7px;
`;

const FilterActionItem = `
  cursor: pointer;
  transition: color ${TransitionConfig};
`;

const FilterSelect = `
  color: ${Colors.violet};
  
  &:hover {
    color: ${Colors.shade03}
  }
`;

export const Reset = styled(FilterBase)`
  ${FilterActionItem};
  ${FilterSelect};
`;

export const Icon = styled(IconBase)`
  vertical-align: -5px;
  transition: none;
  
  &.icon-reload {
    margin-left: -11px;
  }
  &.icon-arrow-down {
    margin-left: -7px;    
  }
`;

export const TagText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  max-width: 150px;
  display: inline-block;
  white-space: nowrap;
`;

export const TagIcon = styled.i`
  color: ${Colors.shade08};
  font-size: 28px;
  margin-left: -5px;
  margin-right: 2px;
  
  &:before {
    font-weight: 800;
  }
`;

export const QueryItemContainer = styled.div`
  display: flex;
  justify-content: start  ;
  align-items: center;
  flex-wrap: wrap;

  > * {
    margin: 5px;
  }
`;
